export const PHONE_MIN_DIGITS = 4
export const PHONE_MAX_DIGITS = 17

// Проверка телефона по аналогии с бекендом: допускается '+' в начале,
// все нецифры игнорируются при подсчёте длины; длина от 4 до 17
export default {
  validate (value) {
    if (value === undefined || value === null || value === '') {
      return true
    }
    let v = String(value)
    if (v[0] === '+') {
      v = '+' + v.slice(1).replace(/\D/g, '')
    } else {
      v = v.replace(/\D/g, '')
    }
    const digitsLen = v[0] === '+' ? v.length - 1 : v.length
    return digitsLen >= PHONE_MIN_DIGITS && digitsLen <= PHONE_MAX_DIGITS
  },
  message () {
    return 'validation.phone_length'
  }
}

